<template>
	<button
		@click="$emit('click', $event)"
		:class="classList"
		:type="type"
		:disabled="disabled"
	>
		<slot></slot>
	</button>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			default: 'button',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		block: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: '',
			validator(color) {
				const allowedColors = ['', 'primary', 'secondary', 'thirdly', 'link'];
				return allowedColors.indexOf(color) !== -1;
			},
		},
		small: {
			type: Boolean,
			default: false,
		},
		medium: {
			type: Boolean,
			default: false,
		},
		xLarge: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classList() {
			return [
				'app-button',
				this.color,
				{ 'app-button--disabled': this.disabled },
				{ 'app-button--block': this.block },
				{ 'app-button--small': this.small },
				{ 'app-button--medium': this.medium },
				{ 'app-button--x-large': this.xLarge },
			];
		},
	},
};
</script>
